export default __webpack_public_path__ + "static/media/breakfast.c48ceed5.svg";